module.exports = __webpack_public_path__ + "img/46b-mensagens-recebidas-responder.6ab94045.png";